<div class="opciones">
  <div class="col-md-12">
      <p>
          Elija la opción hacia donde quiere ir.
      </p>
  </div>
  <div class="col-md-12">
      <a target="_blank" [href]="mapasUrl">
          <button mat-raised-button color="primary">Planimetría</button>
      </a>    
  </div>

</div>